module.exports = __webpack_public_path__ + "img/cowboy_hat_face.df5c2742.gif";